import { FC } from 'react';
import {
  getPartnerStatus,
  getPartnerKycState,
} from '../../../constants/partnerStatus';

interface StatusBadgeProps {
  type: 'status' | 'kyc';
  value: string;
  className?: string;
}

const StatusBadge: FC<StatusBadgeProps> = ({ type, value, className = '' }) => {
  const config =
    type === 'status' ? getPartnerStatus(value) : getPartnerKycState(value);

  return (
    <span
      className={`inline-flex items-center rounded-full px-3 py-1 text-xs font-medium ${config.color} text-white ${className}`}
    >
      {config.label}
    </span>
  );
};

export default StatusBadge;
